<template>
  <div
    class="footer-wrapper"
    :class="{
      login:
        $route.path === 'login' ||
        $route.path === '/login' ||
        $route.path === '/expertLogin' ||
        $route.path === '/forgotpwd',
    }"
  >
    <div class="footer">
      <div class="container">
        <div class="left">
          <div>
            {{ cos.cosver }} <span>网站访问量：{{ cos.cosvisittotal }}次</span>
          </div>
          <div>
            <a href="http://beian.miit.gov.cn" target="bank"
              >粤ICP备10028794号</a
            >
          </div>
          <div>平台直线：{{ cos.costel }}</div>
          <!-- <div>网站访问量：{{cos.cosvisittotal}}次</div> -->
          <div>代理服务：{{ cos.cosaddr }}</div>
          <div>技术支持：广东元正招标采购有限公司</div>
        </div>
        <div class="right">
          <div class="text">
            <div>扫一扫关注</div>
            <div>{{ cos.cosname }}</div>
            <div>微信公众号</div>
          </div>
          <div class="pic">
            <img :src="picAddr + cos.cosqrcode" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import request from "@/utils/request";
export default {
  name: "Footer",
  data() {
    return {
      count: 1000,
      model: {},
      cosvisittota: 0,
    };
  },
  created() {
    this.getCosModel();
  },
  mounted() {
    this.updatattota();
  },
  methods: {
    async getCosModel() {
      let res = await request({
        method: "get",
        url: "/web/web/getWebCosList",
        params: { cosflg: 1 },
      });

      this.model = res.length ? res[0] : {};
    },
    async updatattota() {
      await request({
        method: "get",
        url: "/web/web/updatattota",
        params: { cosflg: 1 },
      });
    },
  },
  computed: {
    ...mapGetters(["picAddr", "cos"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

@media screen and (min-width: 1201px) {
  .footer-wrapper {
    background-color: $color-blue;
    color: $color-greyish-white;
    font-size: $fontsize-medium;
    .footer {
      display: flex;
      justify-content: center;
      .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1201px;
        height: 138px;
        line-height: 21px;
        .left {
          text-align: left;
        }
        .right {
          display: flex;
          align-items: center;
          height: 85px;
          .text {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            padding-right: 15px;
          }
          .pic {
            background-color: #ffffff;
            width: 85px;
            height: 85px;
            img {
              width: 85px;
              height: 85px;
            }
          }
        }
      }
    }
  }
}
.login {
  background-color: $color-bg-white;
  color: $color-black;
}
@media screen and (max-width: 1200px) {
  .footer-wrapper {
    background-color: $color-blue;
    color: $color-greyish-white;
    font-size: $fontsize-medium;
    .footer {
      .container {
        .left {
          div {
            padding: 10px 10px;
            span {
              display: block;
            }
          }
        }
        .right {
          padding-bottom: 20px;
          .text {
            padding: 0 10px;
            div {
              padding: 10px 0;
            }
          }
          .pic {
            width: 150px;
            height: 150px;
            margin: 10px 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
